import './atlas-perspectives-details-panel.scss';

const AtlasPerspectiveDetailPanel = ({ perspective }: any) => {
  // Define a fallback perspective if none is provided
  const placeholderPerspective = {
    label: 'No perspective selected',
    description: 'Placeholder description.',
  };

  // Use either the given perspective or the placeholder
  const currentPerspective = perspective || placeholderPerspective;

  return (
    <div className="perspective-detail-panel">
      <div className="detail-header">
        <h3>Perspective: {currentPerspective.label}</h3>
      </div>
      <div className="detail-content">
        <h3 className="description">Description</h3>
        <p>{currentPerspective.description || 'No description available.'}</p>
      </div>
    </div>
  );
};

export default AtlasPerspectiveDetailPanel;
